export const SET_IMAGE_DATA = 'image/SET_IMAGE_DATA'